// src/LoginPage.tsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setUser } from '../../store/userSlice';
import { RootState } from '../../store/store';
import './login.scss';
import { authService } from '../../services/apiService';

const LoginPage: React.FC = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state: RootState) => state.user.user);
  const isInitialized = useSelector((state: RootState) => state.user.isInitialized);

  // Redirect if user is already logged in
  useEffect(() => {
    if (isInitialized && user) {
      if (user.role === 'USER' || user.role === 'ADMIN') {
        navigate('/map');
      } else {
        navigate('/companies');
      }
    }
  }, [user, isInitialized, navigate]);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null); // Reset error state

    try {
      const data = await authService.login({
        username,
        password,
      });

      console.log(data);
      console.log(data.user.role);

      dispatch(
        setUser({
          email: data.user.email,
          role: data.user.role,
          firstName: data.user.firstName,
          lastName: data.user.lastName,
          companyId: data.user.companyId, // Assuming the user has only one company
          token: data.token,
          refreshToken: data.refreshToken,
        }),
      );

      // Redirect to the jobSiteList page
      if (data && (data.user.role === 'USER' || data.user.role === 'ADMIN')) {
        navigate('/map');
      } else {
        navigate('/companies');
      }
    } catch (error) {
      console.error('Login error:', error);
      setError('Login failed. Please check your credentials.');
    }
  };

  // Don't render login form if user is already authenticated
  if (isInitialized && user) {
    return null;
  }

  return (
    <div className="login-container">
      <form className="login-form" onSubmit={handleLogin}>
        <h2>Login</h2>
        {error && <p className="error">{error}</p>}
        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="password">Password</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit" className="login-button">
          Login
        </button>
      </form>
    </div>
  );
};

export default LoginPage;
